import * as React from "react";
import classNames from "classnames";

import {IIcon} from "../../IIcon";
import {SvgIcon} from "./SvgIcon";

export const EyeCrossedIcon = (props: IIcon) => {
    const {fillColor, size, wrapperColor, wrapperSize} = props;
    const className = classNames(props.className);

    return (
        <SvgIcon size={size || "1"} className={className} fillColor={fillColor} wrapperColor={wrapperColor} wrapperSize={wrapperSize}>
            <path d="M4.93,3.45l1.4,1.4V4.78A1.34,1.34,0,0,0,5,3.44Z" />

            <path d="M5,2.55A2.23,2.23,0,0,1,7.23,4.78a2.21,2.21,0,0,1-.16.81l1.3,1.3A5.3,5.3,0,0,0,9.9,4.78a5.26,5.26,0,0,0-6.68-3l1,1A2.17,2.17,0,0,1,5,2.55Z" />

            <path d="M.54,1.34l1,1,.2.2A5.35,5.35,0,0,0,.1,4.78,5.25,5.25,0,0,0,7,7.74l.19.19,1.3,1.3L9,8.67,1.11.77ZM3,3.8l.69.69a1.35,1.35,0,0,0,0,.29A1.34,1.34,0,0,0,5,6.11a1.43,1.43,0,0,0,.29,0L6,6.77A2.17,2.17,0,0,1,5,7,2.22,2.22,0,0,1,2.77,4.78,2.18,2.18,0,0,1,3,3.8Z" />
        </SvgIcon>
    );
};
